import {
    StreetSnap,
  } from '.';
import {
    HomeLayout
  } from '../layout';
  export default {
    path: '/streetsnap',
    name: 'StreetSnap',
    component: HomeLayout,
    childRoutes: [
      { path: ':streetSnapId', name: 'StreetSnap', component: StreetSnap}
    //   { path: 'counter', name: 'Counter page', component: CounterPage },
    //   { path: 'reddit', name: 'Reddit list page', component: RedditListPage },
    ],
  };
  


// WEBPACK FOOTER //
// ./src/features/streetSnap/route.js